export default __webpack_public_path__ + "static/media/checkmark.db7527f2.png";